export default "__VITE_ASSET__CASS8u54__"